import { i18n } from '@lingui/core'
import { Trans } from '@lingui/macro'
import * as React from 'react'

import { currencyCode } from '@emico/currency-code'

import { TweakwiseNavigationFacet } from '../../../../../graphql/schema.generated'

const TweakwiseFilterValue = ({
    filter,
    value,
}: {
    filter: TweakwiseNavigationFacet
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any
}) => {
    switch (filter.facetSettings.selectionType) {
        case 'checkbox':
            if (filter.facetSettings.urlKey.includes('color')) {
                return (
                    <>
                        {value
                            .map((color: string) => color.split('_')[0])
                            .join(', ')}
                    </>
                )
            } else {
                return <>{value.join(', ').replace(/-/gi, '/')}</>
            }
        case 'slider': {
            const [min, max] = value?.[0].split('-') ?? [0, 0]

            return (
                <Trans id="catalog.tweakwiseFilterValue.priceRange">
                    {Intl.NumberFormat(i18n.locale, {
                        style: 'currency',
                        currency: currencyCode() ?? 'EUR',
                        minimumFractionDigits: 0,
                    }).format(Number(min))}{' '}
                    -{' '}
                    {Intl.NumberFormat(i18n.locale, {
                        style: 'currency',
                        currency: currencyCode() ?? 'EUR',
                        minimumFractionDigits: 0,
                    }).format(Number(max))}
                </Trans>
            )
        }
        // TODO case 'TweakwiseSwatchFilter':
        default:
            return <>{String(value)}</>
    }
}

export default TweakwiseFilterValue
